<template>
    <div >
        <el-input v-model="myValue" :placeholder="placeholder" :type="type" @keyup.enter.native="handleEnter">
            <span slot="prefix">
                <span style="padding: 4px;"> <i class="el-input__icon iconfont" :class="icon"></i></span>
            </span>
            <template v-if="append" slot="append"><img @click="resetUrl"
                    style=" height: 34px;margin:0 4px;cursor: pointer;" :src="src" /></template>
        </el-input>
    </div>
</template>
<script>

export default {
    props: {
        append: {
            type: Boolean,
            default: false
        },
        appendUrl: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: "请输入"
        },
        icon: {
            type: String,
            default: ""
        }, type: {
            type: String,
            default: "text"
        },
        showPassword: {
            type: Boolean,
            default: false
        },

        value: {
            type: String,
            default: ""
        },

    },
    data() {
        return {
            myValue: "",
            src: "",
        }
    },
    mounted() {
        if (this.appendUrl) {
            this.resetUrl();
        }
        //监听登录失败事件，登录失败就重新刷新验证码
        this.$bus.$on("login-fail", () => {
            this.resetUrl();
        })
    },
    methods: {
        handleEnter() {
            console.log("enter")
            this.$emit('enter');
        },
        resetUrl() {
             var timestamp = Date.now();
   
      //生成4位随机数
      var random = Math.floor(Math.random() * 10000);
      //不足4位，前面补0
      random = random.toString().padStart(4, '0');
      console.log(random)
      //取时间戳前面3位+随机数+时间戳后面3位
      var timestampRandom = timestamp.toString().substring(0, 3) + random + timestamp.toString().substring(3, 13);
      //将时间戳随机数赋值给headers
            this.src = this.appendUrl + "&r=" + Math.random()+"&ts="+timestampRandom
        }
    },

    watch: {
        myValue(val) {
            this.$emit("input", val);
        }, value(val) {

            this.myValue = val;
        },
    }

}
</script>
<style lang="scss" scoped>
::v-deep {
    .el-input-group__append {
        padding: 0 0px;
    }
}
</style>